import axios from 'axios';

const API_BASE = '/api';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const authService = {
  login: (username, password) => 
    api.post('/auth/login', { username, password }),
  
  logout: () => 
    api.post('/auth/logout'),
  
  checkAuth: () => 
    api.get('/auth/check')
};

export const screensService = {
  getAll: () => 
    api.get('/screens'),
  
  getOne: (id) => 
    api.get(`/screens/${id}`),
  
  update: (id, data) =>
    api.put(`/screens/${id}`, data),

  sendCommand: (id, command, params = {}) => 
    api.post(`/screens/${id}/command`, { command, params }),
  
  sendGroupCommand: (groupId, command, params = {}) =>
    api.post(`/screens/group/${groupId}/command`, { command, params }),

  requestScreenshot: (id) =>
    api.post(`/screens/${id}/screenshot/request`),

  delete: (id) =>
    api.delete(`/screens/${id}`),

  setOverride: (data) =>
    api.post('/screens/override', data),

  clearOverride: (id) =>
    api.delete(`/screens/${id}/override`)
};

export const groupsService = {
  getAll: () => 
    api.get('/groups'),
  
  create: (data) => 
    api.post('/groups', data),
  
  update: (id, data) => 
    api.put(`/groups/${id}`, data),
  
  delete: (id) => 
    api.delete(`/groups/${id}`)
};

export const dashboardService = {
  getStats: () => 
    api.get('/dashboard/stats')
};

export const playlistsService = {
  getAll: () => 
    api.get('/playlists'),
  
  getOne: (id) => 
    api.get(`/playlists/${id}`),
  
  create: (data) => 
    api.post('/playlists', data),
  
  update: (id, data) => 
    api.put(`/playlists/${id}`, data),
  
  delete: (id) => 
    api.delete(`/playlists/${id}`)
};

export const schedulesService = {
  getAll: () => 
    api.get('/schedules'),
  
  create: (data) => 
    api.post('/schedules', data),
  
  update: (id, data) => 
    api.put(`/schedules/${id}`, data),
  
  delete: (id) => 
    api.delete(`/schedules/${id}`)
};

export const displayService = {
  getAll: () => 
    api.get('/display'),
  
  getOne: (id) => 
    api.get(`/display/${id}`),
  
  create: (data) => 
    api.post('/display', data),
  
  update: (id, data) => 
    api.put(`/display/${id}`, data),
  
  delete: (id) => 
    api.delete(`/display/${id}`),
  
  uploadVideo: (id, formData) => 
    api.post(`/display/${id}/video`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  
  uploadHeaderLogo: (id, formData) =>
    api.post(`/display/${id}/header-logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),

  uploadLogo: (id, formData) => 
    api.post(`/display/${id}/logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  
  duplicate: (id, name) => 
    api.post(`/display/${id}/duplicate`, { name })
};

export default api;
